import { FieldTypeAsset } from '@allesauto/utils/consts';

export enum DisplayValueTypes {
  startingPrice = 'startingPrice',
  vehiclesAmount = 'vehiclesAmount',
  default = 'default',
}

export enum BackgroundColors {
  WHITE = 'WHITE',
  GREY = 'GREY',
}

export enum FontColors {
  WHITE = 'WHITE',
  GREY = 'GREY',
  PURPLE = 'PURPLE',
  BLACK = 'BLACK',
  GREEN = 'GREEN',
}

export interface FilterCarBrandsItem {
  _uid: string;
  brandDescription: string;
  offersAmount: number;
  price: number;
  searchUrl: string;
  logo: FieldTypeAsset;
  brand: string;
}

export interface FilterCarBrandsProps {
  _uid: string;
  component: string;
  background: 'WHITE' | 'GREY';
  heading: string;
  description: string;
  displayValue: DisplayValueTypes;
  items: FilterCarBrandsItem[];
  filterCarBrandsItems: FilterCarBrandsItem[];
  priceFontColor: FontColors;
  vehiclesAmountFontColor: FontColors;
  displayShowMoreButton: boolean;
}

export type FilterCarBrandsListProps = FilterCarBrandsItem &
  Pick<
    FilterCarBrandsProps,
    'displayValue' | 'background' | 'priceFontColor' | 'vehiclesAmountFontColor'
  >;
